import {
    LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST,
    LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_FAILURE,
    LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_SUCCESS,
    LEAD_MANAGE_GET_LEADS_STATUS,
    LEAD_MANAGE_GET_LEADS_STATUS_SUCCESS,
    LEAD_MANAGE_GET_LEADS_STATUS_FAILURE,
} from '../constants/lead_manage_leads_status.constants';

export const leadManageChangeLeadsStatusRequest = (_id, status_id, requestParams) => ({
    type: LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST,
    _id,
    status_id,
    requestParams,
});
export const leadManageChangeLeadsStatusRequestSuccess = (payload) => ({
    type: LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_SUCCESS,
    payload,
});
export const leadManageChangeLeadsStatusRequestFailure = (error) => ({
    type: LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_FAILURE,
    error,
});


export const leadManageGetLeadsStatusRequest = () => ({
    type: LEAD_MANAGE_GET_LEADS_STATUS,
});

export const leadManageGetLeadsStatusSuccess = (leadsStatus) => ({
    type: LEAD_MANAGE_GET_LEADS_STATUS_SUCCESS,
    leadsStatus,
});

export const leadManageGetLeadsStatusFailure = (error) => ({
    type: LEAD_MANAGE_GET_LEADS_STATUS_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/lead_manage_lead_status.actions.js